import { Inject } from '@odinjs/odin';
import { FormAPI, ThemeTonalRange } from '@philips-internal/oswald-ui-components';
import { Value } from '@philips-internal/oswald-ui-core';
import Controller, { OnBeforeCancel, OnBeforeSubmit } from '@philips-internal/oswald-ui-core/lib/client';
import './index.css';
import { SubmitEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { HttpService } from '@philips-internal/oswald-ui-core/lib/services';
import { applicationContext, foundationContext } from '@philips-internal/oswald-ui-foundation';

import { ApplicationRoute, ModulesRoute } from '../../../constants';
import { Endpoint } from '../../../constants/endpoints';
import showSuccessToast from '../../../utils/show-toast';
import BaseController from '../../BaseController';
import { DialogType, ModalType, SimpleDialog, SimpleDialogParams } from '../../dialog-helper/dialog-helper';

interface OpinionRequestDTO {
  userOpinion?: OpinionUserDTO;
  notes: string;
}

interface OpinionUserDTO {
  userSequence: string;
  personName: string;
  nmUser: string;
}

@Controller({ fragment: 'opinion-request', component: 'layout-main' })
export default class OpinionRequestController extends BaseController {

  @Inject('form-opinion-request')
    formOpinionRequestApi: FormAPI;

  @OnBeforeCancel({ target: 'form-opinion-request' })
  onFormBeforeCancel(): void {

    const record = this.formOpinionRequestApi.getRecord();
    this.formOpinionRequestApi.setRecord(record);
    this.formOpinionRequestApi.setDisabled(true);

    const dialogParams: SimpleDialogParams = {
      closeable: false,
      descriptionDialog: 'approval.discard.changes',
      dialogType: DialogType.ACTION,
      modalType: ModalType.DIALOG,
      onClickCancel: () => { this.cancelDiscard();},
      onClickOk: () => { this.discard();},
      titleDialog: 'approval-request.opinion',
      titleOnCancel: 'tws.form.cancel',
      titleOnOk: 'approval.discard',
      theme: ThemeTonalRange.VERY_DARK,
    };
    SimpleDialog.openDialog(dialogParams);
  }

  @OnBeforeSubmit({ target: 'form-opinion-request' })
  onBeforeSubmit(event: SubmitEvent) : void {
    this.formOpinionRequestApi.setLoading(true);
    const { id, processId } = this.historyService.getCurrentRouteParams();
    const requestOpinion = event.record as OpinionRequestDTO;

    const body: Record<string, Value> = {
      approvalSequence: id as Value,
      processSequence: processId as Value,
      loggedUser: foundationContext.getUser()?.username,
      opinionUser: requestOpinion.userOpinion?.nmUser,
      note: requestOpinion.notes,
      establishment: foundationContext.getEstablishment()?.id,
    };

    HttpService.post(Endpoint.OPINION_REQUEST, {}, { body }).then(() => {
      applicationContext.redirect(
        `${ModulesRoute.APPROVALS}${ApplicationRoute.APPROVAL_LIST}`
      );
      showSuccessToast('request-opinion-complete-toast', 'pending.approval.action.completed.successfully');
    }).catch((err: string) => {
      this.formOpinionRequestApi.setLoading(false);
      SimpleDialog.showErrorMessage(err, ThemeTonalRange.VERY_DARK);
      this.formOpinionRequestApi.setEditing(true);
    });
  }

  cancelDiscard(): void {
    this.formOpinionRequestApi.setDisabled(false);
    this.formOpinionRequestApi.setEditing(true);
  }

  discard(): void {
    applicationContext.redirect(
      `${ModulesRoute.APPROVALS}${ApplicationRoute.APPROVAL_LIST}`
    );
  }
}
